'use client';

import type {
  GetReverseProposalBrandsServiceRequest,
  GetReverseProposalBrandsServiceResponse,
} from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useReverseProposalBrands = (
  params: Omit<GetReverseProposalBrandsServiceRequest, 'page'>,
) => {
  return useInfiniteQuery({
    ...curatorQueries.campaigns.reverseProposalBrands(params),
    initialPageParam: 1,
    getNextPageParam: (lastPage: GetReverseProposalBrandsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
  });
};
